import { Box, Stack, Text, Tooltip } from "@mantine/core"

import { RightPanelProps } from "@costory/types/endpoints/DropdownTypes"

import { truncateLabel } from "@costory/front/utils/charts"

const RightPanel = ({
  item,
  title,
  description,
  formula,
  sampleValues = [],
  noDataMessage = "No data available",
  datasource,
  rawMetric,
}: RightPanelProps) => {
  const displayTitle = title || item?.label || ""
  const displayDescription = description || ""
  const displayFormula = formula || ""

  return (
    <>
      <Box px="md" pt="md" pb="xs">
        <Text size="sm" fw={500}>
          {displayTitle}
        </Text>
        {displayDescription && (
          <Text size="xs" c="dimmed" mt="xs">
            {displayDescription}
          </Text>
        )}
        {datasource && (
          <Text size="xs" c="dimmed" mt="xs">
            <b>Metric used:</b> {rawMetric} ({datasource.name})
          </Text>
        )}
        {displayFormula && (
          <Text size="xs" c="dimmed" mt="xs">
            <b>Formula:</b> {displayFormula}
          </Text>
        )}
        {sampleValues.length > 0 && (
          <Text size="xs" c="dimmed" mt="xs">
            Sample values:
          </Text>
        )}
      </Box>
      {sampleValues.length > 0 && (
        <Box px="md" pb="md">
          <Stack gap="xs" align="flex-start">
            {sampleValues.map((val, idx) => (
              <Tooltip
                key={idx}
                label={val}
                multiline
                maw={500}
                style={{ wordBreak: "break-word" }}
              >
                <Text
                  size="sm"
                  style={{ cursor: "default" }}
                  onCopy={(e) => {
                    e.preventDefault()
                    e.clipboardData.setData("text/plain", val)
                  }}
                >
                  {truncateLabel(val, 40)}
                </Text>
              </Tooltip>
            ))}
          </Stack>
        </Box>
      )}
      {sampleValues.length === 0 && !displayDescription && !displayFormula && (
        <Box px="md" pb="md">
          <Text size="sm" c="dimmed">
            {noDataMessage}
          </Text>
        </Box>
      )}
    </>
  )
}

export default RightPanel
